import { BOOK_PLAN_IDS, type BookPlanId } from '@kitup/book-schema';

const CHOSEN_PLAN_KEY = 'kitup:chosen-plan';
/** Long enough for a sign-up and its email; short enough not to surprise the next visit. */
const CHOSEN_PLAN_TTL_MS = 2 * 24 * 60 * 60 * 1000;

export function chosenPlan(): BookPlanId | undefined {
  const fromUrl = new URLSearchParams(globalThis.location?.search ?? '').get('plan');
  let stored: string | null = null;
  try {
    const raw = globalThis.localStorage?.getItem(CHOSEN_PLAN_KEY) ?? null;
    const [plan, at] = (raw ?? '').split('@');
    // Stored as `<plan>@<ms>`; a stale or older plain value is no choice any more.
    if (plan && at && Date.now() - Number(at) < CHOSEN_PLAN_TTL_MS) stored = plan;
  } catch {
    // Storage can be off (private mode); the URL alone still works.
  }
  const value = fromUrl ?? stored;
  return BOOK_PLAN_IDS.find((id) => id === value);
}

export function forgetChosenPlan(): void {
  try {
    globalThis.localStorage?.removeItem(CHOSEN_PLAN_KEY);
  } catch {
    // Nothing to forget.
  }
}

/**
 * Kept across sign-up, which leaves the page for the confirmation email and comes back —
 * usually in another tab, which is why it is localStorage and not sessionStorage (per tab).
 * It is forgotten once a book takes it, and lapses after two days: browsers are shared, and
 * a plan picked weeks ago is no longer anyone's choice.
 */
export function rememberChosenPlan(search: string): void {
  const value = new URLSearchParams(search).get('plan');
  if (!BOOK_PLAN_IDS.some((id) => id === value)) return;
  try {
    globalThis.localStorage?.setItem(CHOSEN_PLAN_KEY, `${value!}@${Date.now()}`);
  } catch {
    // The builder falls back to its default plan.
  }
}
